import { createGetRequest, useGetRequestBase } from "_utils/useFetch";

const configFileUri = window.location.origin + "/config.json";

interface ConfigVars {
  readonly ENVIRONMENT: string;
  readonly OKTA_ISSUER: string;
  readonly OKTA_CLIENT_ID: string;
  readonly API_BASE_URL: string;
}

const initialConfig: ConfigVars = {
  ENVIRONMENT: "",
  OKTA_ISSUER: "",
  OKTA_CLIENT_ID: "",
  API_BASE_URL: "",
};

export const useConfig = () => {
  const request = createGetRequest<undefined, ConfigVars>(configFileUri);
  const { data: config } = useGetRequestBase("configs", request, undefined);
  return config || initialConfig;
};
